var $8f6a480bb40b134f$exports = {};
const $8f6a480bb40b134f$var$mobileButton = document.getElementById('mobile-b');
const $8f6a480bb40b134f$var$backendButton = document.getElementById('backend-b');
const $8f6a480bb40b134f$var$frontendButton = document.getElementById('frontend-b');
// const designButton = document.getElementById('design-b');
const $8f6a480bb40b134f$var$developmentButton = document.getElementById('development-b');
const $8f6a480bb40b134f$var$mobile = document.getElementById('mobile-t');
const $8f6a480bb40b134f$var$backend = document.getElementById('backend-t');
const $8f6a480bb40b134f$var$frontend = document.getElementById('frontend-t');
// const design = document.getElementById('design-t');
const $8f6a480bb40b134f$var$development = document.getElementById('development-t');
const $8f6a480bb40b134f$var$x1_circle = document.getElementById('x1-circle');
const $8f6a480bb40b134f$var$x2_circle = document.getElementById('x2-circle');
const $8f6a480bb40b134f$var$x3_circle = document.getElementById('x3-circle');
const $8f6a480bb40b134f$var$x4_circle = document.getElementById('x4-circle');
const $8f6a480bb40b134f$var$x5_circle = document.getElementById('x5-circle');
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT START
// for(let i=0;i<array.length;i++){
// console.log(array[i]);
// // if(array[i].classList.contain(''))
// }
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT END
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT START
// function designHover() {
//   const firstGridDesign = document.getElementById('first-grid-design');
//   const secondGridDesign = document.getElementById('second-grid-design');
//   const thirdGridDesign = document.getElementById('third-grid-design');
//   const forthGridDesign = document.getElementById('forth-grid-design');
//   const gridContainerDesign = document.getElementById('grid-container-design');
//   gridContainerDesign.addEventListener('mouseleave', () => {
//     firstGridDesign.classList.add('grid-split');
//   })
//   // sixthGrid.addEventListener('mouseover', () => {
//   //   firstGrid.classList.add('grid-split');
//   // })
//   const array1 = [firstGridDesign, secondGridDesign, thirdGridDesign, forthGridDesign];
//   array1.forEach((item, index) => {
//     item.addEventListener('mouseover', () => {
//       array1.forEach((gridItem, i) => {
//         if (index === i) {
//           gridItem.classList.add('grid-split');
//         } else {
//           gridItem.classList.remove('grid-split');
//         }
//       })
//     })
//     item.addEventListener('mouseleave', () => {
//       array1.forEach((gridItem, i) => {
//         gridItem.classList.remove('grid-split');
//       })
//     })
//   })
// }
// FIRST DEFAULT AND THEN HOVER SHOW EFFECT END
$8f6a480bb40b134f$var$mobileButton.onclick = function() {
    if ($8f6a480bb40b134f$var$mobile.style.display !== "none" && $8f6a480bb40b134f$var$x1_circle.style.display !== "none") {
        $8f6a480bb40b134f$var$mobile.style.display = "block";
        $8f6a480bb40b134f$var$x1_circle.style.display = "block";
    } else {
        $8f6a480bb40b134f$var$mobile.style.display = "block";
        $8f6a480bb40b134f$var$x1_circle.style.display = "block";
        $8f6a480bb40b134f$var$backend.style.display = "none";
        $8f6a480bb40b134f$var$frontend.style.display = "none";
        $8f6a480bb40b134f$var$development.style.display = "none";
    }
    $8f6a480bb40b134f$var$developmentButton.style.background = "white";
    $8f6a480bb40b134f$var$developmentButton.style.color = "black";
    $8f6a480bb40b134f$var$mobileButton.style.background = "#5C3EB3";
    $8f6a480bb40b134f$var$mobileButton.style.color = "white";
    $8f6a480bb40b134f$var$backendButton.style.background = "white";
    $8f6a480bb40b134f$var$backendButton.style.color = "black";
    $8f6a480bb40b134f$var$frontendButton.style.background = "white";
    $8f6a480bb40b134f$var$frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
};
$8f6a480bb40b134f$var$backendButton.onclick = function() {
    if ($8f6a480bb40b134f$var$backend.style.display !== "none" && $8f6a480bb40b134f$var$x2_circle.style.display !== "none") {
        $8f6a480bb40b134f$var$backend.style.display = "block";
        $8f6a480bb40b134f$var$x2_circle.style.display = "block";
    } else {
        $8f6a480bb40b134f$var$backend.style.display = "block";
        $8f6a480bb40b134f$var$x2_circle.style.display = "block";
        $8f6a480bb40b134f$var$mobile.style.display = "none";
        $8f6a480bb40b134f$var$frontend.style.display = "none";
        $8f6a480bb40b134f$var$development.style.display = "none";
    }
    $8f6a480bb40b134f$var$developmentButton.style.background = "white";
    $8f6a480bb40b134f$var$developmentButton.style.color = "black";
    $8f6a480bb40b134f$var$mobileButton.style.background = "white";
    $8f6a480bb40b134f$var$mobileButton.style.color = "black";
    $8f6a480bb40b134f$var$backendButton.style.background = "#5C3EB3";
    $8f6a480bb40b134f$var$backendButton.style.color = "white";
    $8f6a480bb40b134f$var$frontendButton.style.background = "white";
    $8f6a480bb40b134f$var$frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
};
$8f6a480bb40b134f$var$frontendButton.onclick = function() {
    if ($8f6a480bb40b134f$var$frontend.style.display !== "none" && $8f6a480bb40b134f$var$x3_circle.style.display !== "none") {
        $8f6a480bb40b134f$var$frontend.style.display = "block";
        $8f6a480bb40b134f$var$x3_circle.style.display = "block";
    } else {
        $8f6a480bb40b134f$var$frontend.style.display = "block";
        $8f6a480bb40b134f$var$x3_circle.style.display = "block";
        $8f6a480bb40b134f$var$backend.style.display = "none";
        $8f6a480bb40b134f$var$development.style.display = "none";
        $8f6a480bb40b134f$var$mobile.style.display = "none";
    }
    $8f6a480bb40b134f$var$developmentButton.style.background = "white";
    $8f6a480bb40b134f$var$developmentButton.style.color = "black";
    $8f6a480bb40b134f$var$mobileButton.style.background = "white";
    $8f6a480bb40b134f$var$mobileButton.style.color = "black";
    $8f6a480bb40b134f$var$backendButton.style.background = "white";
    $8f6a480bb40b134f$var$backendButton.style.color = "black";
    $8f6a480bb40b134f$var$frontendButton.style.background = "#5C3EB3";
    $8f6a480bb40b134f$var$frontendButton.style.color = "white";
// designButton.style.background = "whte";
// designButton.style.color = "black";
};
// if (designButton) {
//   designButton.onclick = function () {
//     if (design.style.display !== "none" && x4_circle.style.display !== "none") {
//       design.style.display = "block";
//       x4_circle.style.display = "block"
//     } else {
//       design.style.display = "block";
//       x4_circle.style.display = "block"
//     }
//   };
// }
$8f6a480bb40b134f$var$developmentButton.onclick = function() {
    if ($8f6a480bb40b134f$var$development.style.display !== "none" && $8f6a480bb40b134f$var$x5_circle.style.display !== "none") {
        $8f6a480bb40b134f$var$development.style.display = "block";
        $8f6a480bb40b134f$var$x5_circle.style.display = "block";
    } else {
        $8f6a480bb40b134f$var$development.style.display = "block";
        $8f6a480bb40b134f$var$x5_circle.style.display = "block";
        $8f6a480bb40b134f$var$development.style.display = "block";
        $8f6a480bb40b134f$var$x5_circle.style.display = "block";
        $8f6a480bb40b134f$var$backend.style.display = "none";
        $8f6a480bb40b134f$var$frontend.style.display = "none";
        $8f6a480bb40b134f$var$mobile.style.display = "none";
    }
    $8f6a480bb40b134f$var$developmentButton.style.background = "#5C3EB3";
    $8f6a480bb40b134f$var$developmentButton.style.color = "white";
    $8f6a480bb40b134f$var$mobileButton.style.background = "white";
    $8f6a480bb40b134f$var$mobileButton.style.color = "black";
    $8f6a480bb40b134f$var$backendButton.style.background = "white";
    $8f6a480bb40b134f$var$backendButton.style.color = "black";
    $8f6a480bb40b134f$var$frontendButton.style.background = "white";
    $8f6a480bb40b134f$var$frontendButton.style.color = "black";
};
// function opendropdown() {
//   var x = document.getElementById("dropdown");
//   if (x.style.display === "block") {
//     x.style.display = "none";
//   } else {
//     x.style.display = "block";
//   }
// }
// const getAndroidValue = document.getElementById('getAndroidVal');
// getAndroidValue.addEventListener('click', function getAndroidVal() {
//   window.location.href = "./hire-talent.html";
// })
// TRANSPARENT SCROLLING NAVBAR THEN WHITE NAVBAR EFFECT
function $8f6a480bb40b134f$var$hellos() {
    if ($8f6a480bb40b134f$var$development.style.display !== "none" && $8f6a480bb40b134f$var$x5_circle.style.display !== "none") {
        $8f6a480bb40b134f$var$development.style.display = "block";
        $8f6a480bb40b134f$var$x5_circle.style.display = "block";
    } else {
        $8f6a480bb40b134f$var$development.style.display = "block";
        $8f6a480bb40b134f$var$x5_circle.style.display = "block";
        $8f6a480bb40b134f$var$backend.style.display = "none";
        $8f6a480bb40b134f$var$frontend.style.display = "none";
        $8f6a480bb40b134f$var$mobile.style.display = "none";
    }
    $8f6a480bb40b134f$var$mobileButton.style.background = "white";
    $8f6a480bb40b134f$var$mobileButton.style.color = "black";
    $8f6a480bb40b134f$var$developmentButton.style.background = "#5C3EB3";
    $8f6a480bb40b134f$var$developmentButton.style.color = "white";
    $8f6a480bb40b134f$var$backendButton.style.background = "white";
    $8f6a480bb40b134f$var$backendButton.style.color = "black";
    $8f6a480bb40b134f$var$frontendButton.style.background = "white";
    $8f6a480bb40b134f$var$frontendButton.style.color = "black";
// designButton.style.background = "white";
// designButton.style.color = "black";
}
if (null) {
    null.dispose(function(data) {
        // module is about to be replaced.
        // You can save data that should be accessible to the new asset in `data`
        data.updated = Date.now();
    });
    null.accept(function(getParents) {
        // module or one of its dependencies was just updated.
        // data stored in `dispose` is available in `module.hot.data`
        let { updated: updated } = null.data;
    });
}
window.designHover = designHover;
window.cloudHover = cloudHover;
window.hellos = $8f6a480bb40b134f$var$hellos; // window.opendropdown = opendropdown;
 // window.getAndroidVal = getAndroidVal;


//# sourceMappingURL=about-us.84a4b555.js.map
